import React, { useState, useEffect} from 'react';
//import TaxForm from './TaxForm.js';
import { Calculate, CalculateInterest} from './pages/PaymentRate.js';
import PaymentRate2 from './pages/PaymentRate.js';
import { PaymentRate3 } from './pages/PaymentRate.js';
import { tableData,columns} from './pages/testy/danedowyliczen.js';
import { TotalCost } from './pages/PaymentRate.js';
import FlatInsurance from './pages/Insurances.js';
import { LifeInsurance } from './pages/Insurances.js';
import { PaymentRateDecreasing } from './pages/PaymentRate.js';
import Table from './pages/BNPParibas.js';
import { FlatInsuranceTotal } from './pages/Insurances.js';
import { TotalCostFixed } from './pages/PaymentRate.js';
import { TestTotalCost } from './pages/PaymentRate.js';
import { TotalCostDecreasingFixed } from './pages/PaymentRate.js';
import { LifeInsuranceTotal, PkoBPBK2Insurance } from './pages/Insurances.js';
import { OprPoStałym } from './pages/OprocentowaniePoStałym.js';
import TaxForm from './TaxForm.js';
import { TotalCostDecreasing } from './pages/PaymentRate.js';
import { TotalCostPkobp } from './pages/PaymentRate.js';
import BezpiecznyKredytRata, { BezpiecznyKredytKosztCałkowity, DopłataDoBK2 , BezpiecznyKredytKosztSumaDopłat, BezpiecznyKredytRataDocelowaDecreasing} from './pages/BezpiecznyKredyt2.jsx';
import { BezpiecznyKredytRataDocelowa } from './pages/BezpiecznyKredyt2.jsx';
import { TotalCostInne } from './pages/PaymentRate.js';




function LoanCalculator(props) {
  const [creditValue, setCreditValue] = useState(300000);
  const [loanPeriod, setLoanPeriod] = useState(300);
  const [flatValue, setFlatValue] = useState(400000);
  const [fixedInterest, setFixedInterest] = useState(true);
  const [variableInterest, setVariableInterest] = useState(true);
  const [sort, setSort] = useState("sortByName");
  const [wszystkieBankiCheckbox, setWszystkieBankiCheckbox] = useState(true);
  const [santanderCheckbox, setSantanderChceckbox]= useState(true);
  const [bnpParibasCheckbox, setBnpParibasChceckbox]= useState(true);
  const [millenniumCheckbox, setMillenniumCheckbox ]= useState(true);
  const [pkobpCheckbox, setpkobpcheckbox ]= useState(true);
  const [mbankCheckbox, setMbankcheckbox] = useState(true);
  const [pekaoSACheckbox, setPekaoSAcheckbox] = useState(true);
  const [citiHandlowyCheckbox, setCitiHandlowycheckbox] = useState(true);
  const [bośBankCheckbox, setBośBankCheckbox] = useState(true);
  const [ingBankCheckbox, setIngBankCheckbox] = useState(true);
  const [aliorCheckbox, setAliorCheckbox] = useState(true);
  const [inneCheckbox, setInneCheckbox] = useState(true);
  const [BpsCheckbox, setBpsChceckbox] = useState(true)
  const [rataStałaCzymalejąca, setRataStałaCzyMalejąca] = useState("equalrate");
  const [arr, updateMyArray] = useState([]);
  const [kontoCheckbox, setKontoCheckbox] = useState(true);
  const [ubNieruchomościCheckbox, setUbNieruchomościCheckbox] = useState(true);
  const [kartaKredytowaCheckbox, setKartaKredytowaCheckbox] = useState(true);
  const [ubNaŻycieCheckbox, setUbNaŻycieCheckbox] = useState(true)
  const [ubOdUtratyPracyCheckbox,setUbodUtratyPracyChecbox] = useState(true);
  const [zarobkiNetto, setZarobkiNetto] = useState("zarobki0")


  
  //useEffect(() => {
   // console.log("Component rendered");
  //},[sort]);

 // const onClick = () => {
 //   updateMyArray( arr => [...arr, `${arr.length}`]);
//};

//const [list, setList] = useState([]);


//const handleDelete = () => {
  
//  setList ([...tableData])


//list.sort((a, b) => {
//  return a.marża  - b.marża;
//});
//}


const oprBnpH15 = OprBnpH15();
 const rataBnpH15 = RataBnpH15();
 const oprBnpH110 = OprBnpH110();
 const rataBnpH110 = RataBnpH110();
 const oprBnpH210 = OprBnpH210();
 const rataBnpH210 = RataBnpH210();
 const oprBnpH25 = OprBnpH25();
 const rataBnpH25 = RataBnpH25();
 const oprBnpStan10 = OprBnpStand10();
 const rataBnpStan10 = RataBnpStan10();
 const oprBnpStan5 = OprBnpStan5();
 const rataBnpStan5 = RataBnpStan5()

//function sortByNumberOfOptions() {
 // const sortDirection = e.target.value;
 // const clonedOptions = [...listOfOptions];
 // clonedOptions.map((i) => {
      
   

  //  i.rataDocelowa = <PaymentRate3 LTV={LTV} creditValue={creditValue} loanPeriod={loanPeriod} interestRate={Number(i.marża)} id={i.id}/>
  //  console.log(i.rataDocelowa)
  //})

  //clonedOptions.sort((a, b) => {
  //  return a.rataDocelowa  > b.rataDocelowa ? 1 : -1;
  //});

  //setListOfOptions(clonedOptions);
//}

  const handleChangeFixedInterest = () => { 
    
    setFixedInterest(!fixedInterest); 
    
  }; 

  const handleChangeVariableInterest = () => { 
    
    setVariableInterest(!variableInterest); 
    
  };

  const handleChangeWszystkieBankiChceckbox = () => { 
    
    setWszystkieBankiCheckbox(!wszystkieBankiCheckbox)
    setSantanderChceckbox(!santanderCheckbox); 
    setBnpParibasChceckbox(!bnpParibasCheckbox);
    setMillenniumCheckbox(!millenniumCheckbox);
    setpkobpcheckbox(!pkobpCheckbox); 
    setMbankcheckbox(!mbankCheckbox); 
    setPekaoSAcheckbox(!pekaoSACheckbox); 
    setCitiHandlowycheckbox(!citiHandlowyCheckbox); 
    setBośBankCheckbox(!bośBankCheckbox); 
    setIngBankCheckbox(!ingBankCheckbox);
    setAliorCheckbox(!aliorCheckbox);
    setInneCheckbox(!inneCheckbox);
    setBpsChceckbox(!BpsCheckbox);
  }; 

  const handleChangeSantanderChecbox = () => { 
    
    setSantanderChceckbox(!santanderCheckbox); 
    
  }; 

  const handleChangeBpsChecbox = () => { 
    
    setBpsChceckbox(!BpsCheckbox); 
    
  }; 

  const handleChangeAliorChecbox = () => { 
    
    setAliorCheckbox(!aliorCheckbox); 
    
  }; 

  const handleChangeBnpparibasChecbox = () => { 
    
    setBnpParibasChceckbox(!bnpParibasCheckbox); 
    
  }; 

  const handleChangeMillenniumCheckbox = () => { 
    
    setMillenniumCheckbox(!millenniumCheckbox); 
    
  }; 

  const handleChangePkobpCheckbox = () => { 
    
    setpkobpcheckbox(!pkobpCheckbox); 
    
  }; 

  const handleChangeMbankCheckbox = () => { 
    
    setMbankcheckbox(!mbankCheckbox); 
    
  }; 

  const handleChangePekaoSACheckbox = () => { 
    
    setPekaoSAcheckbox(!pekaoSACheckbox); 
    
  }; 

  const handleChangeCitiHandlowyCheckbox = () => { 
    
    setCitiHandlowycheckbox(!citiHandlowyCheckbox); 
    
  }; 

  const handleChangeBośBankCheckbox = () => { 
    
    setBośBankCheckbox(!bośBankCheckbox); 
    
  }; 

  const handleChangeIngBankCheckbox = () => { 
    
    setIngBankCheckbox(!ingBankCheckbox); 
    
  };
  
  const handleChangeInneChecbox = () => { 
    
    setInneCheckbox(!inneCheckbox); 
    
  }; 


  const handlecreditValueChange = (event) => {
    setCreditValue(event.target.value);
  }


  const handleloanPeriodChange = (event) => {
    setLoanPeriod(event.target.value);
  }


  const handleflatValueChange = (event) => {
    setFlatValue(event.target.value);
  }

  const handleChangekontoCheckbox = () => { 
    
    setKontoCheckbox(!kontoCheckbox); 
    
  }; 

  const handleChangeKartaKredytowaCheckbox = () => { 
    
    setKartaKredytowaCheckbox(!kartaKredytowaCheckbox); 
  }; 

  const handleChangeUbNieruchomościCheckbox = () => { 
    
    setUbNieruchomościCheckbox(!ubNieruchomościCheckbox); 
  }; 

  const handleChangeUbNaŻycieCheckbox = () => { 
    
    setUbNaŻycieCheckbox(!ubNaŻycieCheckbox); 
  }; 

  const handleChangeUbOdUtratyPracyCheckbox = () => {
    setUbodUtratyPracyChecbox(!ubOdUtratyPracyCheckbox)
  };

function IleKolumn(props){

    let a = 0;
    let c = 0;
    let LTV = creditValue/flatValue;

   
    tableData.map((data) => {
      if( data.kwotaKredytuOd <= creditValue && data.kwotaKredytuDo >= creditValue){
      if(data.maxLTV >= LTV){
      if(data.oprocentowanieStaleCzZmienne === "Zmienne" && variableInterest){
        if(wszystkieBankiCheckbox){a = a + 1};
        if(!wszystkieBankiCheckbox){

         
          if(data.bank === "Alior" && aliorCheckbox){a = a + 1};
          if(data.bank === "ING" && ingBankCheckbox){a = a + 1};
          if(data.bank === "PEKAOSA" && pekaoSACheckbox){a = a + 1};
          if(data.bank === "BNP Paribas" && bnpParibasCheckbox){a = a + 1};
          if(data.bank === "Millennium" && millenniumCheckbox){a = a + 1}
          if(data.bank === "Santander" && santanderCheckbox){
            
             if(zarobkiNetto === "zarobki1"){
              if(data.wymaganeZarobkiNetto < 4999) 
              {a = a + 1}
             }
  
             if(zarobkiNetto === "zarobki2"){ 
              if(data.wymaganeZarobkiNetto < 6999) 
              {a = a + 1}
             }
      
             if(zarobkiNetto === "zarobki3"){     
              if(data.wymaganeZarobkiNetto < 9999) 
              {a = a + 1}  
             }
          }
          
          if(data.bank === "PKOBP" && pkobpCheckbox){a = a + 1}
          if(data.bank === "mbank" && mbankCheckbox){
            if(zarobkiNetto === "zarobki1"){
              if(data.wymaganeZarobkiNetto < 4999) 
              {a = a + 1}
            }
        
            if(zarobkiNetto === "zarobki2"){ 
                if(data.wymaganeZarobkiNetto < 6999) 
                {a = a + 1}
              }
            
             if(zarobkiNetto === "zarobki3"){     
                if(data.wymaganeZarobkiNetto < 9999) 
                    {a = a + 1}  
               }
                
             }
            
            
            
          if(data.bank === "BPS" && BpsCheckbox){a = a + 1}
          if(data.nazwaOferty === "Bezpieczny Kredyt 2%" && inneCheckbox){a = a + 1}
          if(data.bank === "CITIHandlowy" && citiHandlowyCheckbox){a = a + 1}
          if(data.bank === "BOŚ Bank" && bośBankCheckbox){a = a + 1}
        }
      }
      
    
      if(data.oprocentowanieStaleCzZmienne === "Stałe" && fixedInterest){
        if(wszystkieBankiCheckbox){a = a + 1};
        if(!wszystkieBankiCheckbox){
        if(data.bank === "Alior" && aliorCheckbox){a = a + 1};
        if(data.bank === "ING" && ingBankCheckbox){a = a + 1};
        if(data.bank === "PEKAOSA" && pekaoSACheckbox){a = a + 1};
        if(data.bank === "BNP Paribas" && bnpParibasCheckbox){a = a + 1};
        if(data.bank === "Millennium" && millenniumCheckbox){a = a + 1}
        if(data.bank === "Santander" && santanderCheckbox){
          if(zarobkiNetto === "zarobki1"){
            if(data.wymaganeZarobkiNetto < 4999) 
            {a = a + 1}
          }
      
          if(zarobkiNetto === "zarobki2"){ 
              if(data.wymaganeZarobkiNetto < 6999) 
              {a = a + 1}
            }
          
           if(zarobkiNetto === "zarobki3"){     
              if(data.wymaganeZarobkiNetto < 9999) 
                  {a = a + 1}  
             }
              
              }
          
        
        if(data.bank === "PKOBP" && pkobpCheckbox){a = a + 1}
        if(data.bank === "mbank" && mbankCheckbox){
        if(zarobkiNetto === "zarobki1"){
          if(data.wymaganeZarobkiNetto < 4999) 
          {a = a + 1}
        }
    
        if(zarobkiNetto === "zarobki2"){ 
            if(data.wymaganeZarobkiNetto < 6999) 
            {a = a + 1}
          }
        
         if(zarobkiNetto === "zarobki3"){     
            if(data.wymaganeZarobkiNetto < 9999) 
                {a = a + 1}  
           }
            
            }
      
      
        if(data.bank === "BPS" && BpsCheckbox){a = a + 1}
        if(data.nazwaOferty === "Bezpieczny Kredyt 2%" && inneCheckbox){a = a + 1}
        if(data.bank === "CITIHandlowy" && citiHandlowyCheckbox){a = a + 1}
        if(data.bank === "BOŚ Bank" && bośBankCheckbox){a = a + 1}
        }

      }
    }
  }
 
      return a;
      
    
    })

    tableData.map((data)=>{
      if(zarobkiNetto === "zarobki0"){
        if(data.wymaganeZarobkiNetto >= 0) 
        {c = c + 1}
      }

      if(zarobkiNetto === "zarobki1"){
        if(data.wymaganeZarobkiNetto < 4999) 
        {c = c + 1}
      }
  
      if(zarobkiNetto === "zarobki2"){ 
          if(data.wymaganeZarobkiNetto < 6999) 
          {c = c + 1}
        }
      
       if(zarobkiNetto === "zarobki3"){     
          if(data.wymaganeZarobkiNetto < 9999) 
              {c = c + 1}  
         }

         if(zarobkiNetto === "zarobki4"){
          if(data.wymaganeZarobkiNetto >= 0) 
          {c = c + 1}
        } 
            return c
    })
console.log(a,c)
c = 57 - c;

    return a 
    
  }
  
  function IleKolumnWszystkich(){
    let a = 0;
    tableData.map((data) => {
      if(data.id) {a = a + 1};
      return a; 
    })
    
    return a;
  }

  const b = IleKolumn();


 function SortowanieTablicyPoID(){

    let id = 0;
    const sortPoId = [];
    let LTV = creditValue/flatValue;

   
    tableData.map((data) => {
      if( data.kwotaKredytuOd <= creditValue && data.kwotaKredytuDo >= creditValue){
      if(data.maxLTV >= LTV){
      if(data.oprocentowanieStaleCzZmienne === "Zmienne" && variableInterest){
        if(wszystkieBankiCheckbox){sortPoId.push(id)};
        if(!wszystkieBankiCheckbox){
          if(data.bank === "Alior" && aliorCheckbox){sortPoId.push(data.id)};
          if(data.bank === "ING" && ingBankCheckbox){sortPoId.push(data.id)};
          if(data.bank === "PEKAOSA" && pekaoSACheckbox){sortPoId.push(data.id)};
          if(data.bank === "BNP Paribas" && bnpParibasCheckbox){sortPoId.push(data.id)};
          if(data.bank === "Millennium" && millenniumCheckbox){sortPoId.push(data.id)}
          if(data.bank === "Santander" && santanderCheckbox){sortPoId.push(data.id)}
          if(data.bank === "PKOBP" && pkobpCheckbox){sortPoId.push(data.id)}
          if(data.bank === "mbank" && mbankCheckbox){sortPoId.push(data.id)}
          if(data.bank === "BPS" && BpsCheckbox){sortPoId.push(data.id)}
          if(data.bank === "Inne" && inneCheckbox){sortPoId.push(data.id)}
          if(data.bank === "CITIHandlowy" && citiHandlowyCheckbox){sortPoId.push(data.id)}
          if(data.bank === "BOŚ Bank" && bośBankCheckbox){sortPoId.push(data.id)}
        }
      }
    
      if(data.oprocentowanieStaleCzZmienne === "Stałe" && fixedInterest){
        if(wszystkieBankiCheckbox){sortPoId.push(data.id)};
        if(!wszystkieBankiCheckbox){
        if(data.bank === "Alior" && aliorCheckbox){sortPoId.push(data.id)};
        if(data.bank === "ING" && ingBankCheckbox){sortPoId.push(data.id)};
        if(data.bank === "PEKAOSA" && pekaoSACheckbox){sortPoId.push(data.id)};
        if(data.bank === "BNP Paribas" && bnpParibasCheckbox){sortPoId.push(data.id)};
        if(data.bank === "Millennium" && millenniumCheckbox){sortPoId.push(data.id)}
        if(data.bank === "Santander" && santanderCheckbox){sortPoId.push(data.id)}
        if(data.bank === "PKOBP" && pkobpCheckbox){sortPoId.push(data.id)}
        if(data.bank === "mbank" && mbankCheckbox){sortPoId.push(data.id)}
        if(data.bank === "BPS" && BpsCheckbox){sortPoId.push(data.id)}
        if(data.bank === "Inne" && inneCheckbox){sortPoId.push(data.id)}
        if(data.bank === "CITIHandlowy" && citiHandlowyCheckbox){sortPoId.push(data.id)}
        if(data.bank === "BOŚ Bank" && bośBankCheckbox){sortPoId.push(data.id)}
        }
      }
    }
  }
      return sortPoId;
      
    
    })

    return sortPoId
    
  }

function GenerowanieRaty(){

  const generowanieTablicy = [];
  [...tableData].filter(data => data.oprocentowanieStaleCzZmienne ==="Stałe" && fixedInterest || data.oprocentowanieStaleCzZmienne ==="Zmienne" && variableInterest).filter(data => 
    data.bank==="Santander" && santanderCheckbox || data.bank==="BNP Paribas" && bnpParibasCheckbox || data.bank==="Millennium" && millenniumCheckbox || data.bank==="PKOBP" && pkobpCheckbox
    || data.bank === "mbank" && mbankCheckbox || data.bank === "PEKAOSA" && pekaoSACheckbox || data.bank === "CITIHandlowy" && citiHandlowyCheckbox || data.bank === "BOŚ Bank" && bośBankCheckbox || data.bank === "ING" && ingBankCheckbox || data.bank === "Alior" && aliorCheckbox ||data.bank === "BPS" && BpsCheckbox || data.bank ==="Inne" && inneCheckbox
    ).filter(data => data.kwotaKredytuOd <= creditValue && data.kwotaKredytuDo >= creditValue).filter(data => data.maxLTV >= LTV).map((data)=>{  
      
  
       
      data.rataDocelowa = generowanieTablicy.push(<PaymentRate2 creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża}/>)
 

return generowanieTablicy
    })
 
    return generowanieTablicy
   
    } 
 

  const tableStyle = {
    width: 220 * (b + 1),
    //float: 'auto',
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
 
  }

  const td = {
    border: '1px solid black',
    boxShadow: "0 0 5px rgba(0, 0, 0, 0.15)",

    height: '55px',
   
    textAlign: "center",
  }

  const tr = {
  
  }

  const tableStyleHeader = {
    boxShadow: "0 0 5px rgba(0, 0, 0, 0.15)",
    width: '20%',
    height: 55,
    textAlign: "center",
    padding: '5px',

  }
  
  const checboxStyle = {
  boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
  textAlign: "left",
  padding: '5px',
  }
  
  const checkboxStyle1 ={
    padding: '5px',
  }

  const inputStyle ={
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
    textAlign: "left",
    width:'150px',
    border:'2px solid #aaa',
    borderRadius:'4px',
    margin:'5px 0',
    outline:'none',
    padding:'5px',
    borderColor: 'dodgerBlue',
    //boxShadow:'0 0 8px 0 dodgerBlue',
    textAlign: "center",

  }

  const buttonStyle = {
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
    textAlign: "center",
    borderColor: 'dodgerBlue',
    padding:'1px',
    }

  let LTV = (creditValue/flatValue);
  let interestRate = 8.4;
  //do poprawy dla tabelki z ofertami
  if (LTV <= 0.8) {
    interestRate = 8.4
  }
  if (LTV > 0.8) {
    interestRate = 8.99;
  }
  let interestRateChange = interestRate/1200;
  let interestRateChange2 = interestRate/1.2;
  let interestRateChange3 = interestRate/1200;
  let interestToBase = Math.pow(1 + interestRateChange, loanPeriod); //potęgowanie
  let lowDownInsurance = 0;
  //let wibor3m = 0.0695;
  //let wibor6m = 0.0699;
  let interestCost = (loanPeriod * (creditValue*interestRateChange*interestToBase) / (interestToBase - 1)) - creditValue;
  let rateMonthIntrest = interestRateChange * loanPeriod;
  let creditRate = 1000;
  let creditValue2 = creditValue;
  let ltv2 = 0.8;
  let balance = creditValue;
  let paymentRate = (creditValue*interestRateChange3*Math.pow(1 + interestRateChange3, loanPeriod)) / (Math.pow(1 + interestRateChange3, loanPeriod) - 1)
  let creditLifeInsurance = creditValue*0.0003;
  let creditLifeInsuranceSum = 0;
  let creditValuePEKAOCPI = 0;


  const wiborChange = [
    {bank1: "ALIOR", wibor6m:"3M", wibor: 6.92, data:"07.02.2023"},
    {bank2:"BNP", wibor6m:"3M", wibor: 6.92, data:"07.02.2023"},
    {bank3: "BOŚ", wibor6m:"6M", wibor: 6.99, data:"07.02.2023"},
    {bank4: "BPS", wibor6m:"3M", wibor: 6.92, data:"07.02.2023"},
    {bank5: "CITI HANDLOWY", wibor6m:"3M", wibor: 6.92, data:"07.02.2023"},
    {bank6: "ING", wibor6m:"6M", wibor: 6.99, data:"01.02.2023"},
    {bank7: "MBANK",	wibor6m:"3M", wibor: 7.31, data:"03.12.2022"},
    {bank8: "MILLENNIUM", wibor6m:"6M", wibor: 6.95, data:"31.03.2023"},
    {bank9: "PEKAO SA", wibor6m:	"6M", wibor: 7.03, data:"01.02.2023"},
    {bank10: "PKO BP", wibor6m:"6M", wibor: 6.99, data:"06.02.2023"},
    {bank11:"SANTANDER", wibor6m:"3M", wibor: 6.92, data:"07.02.2023"},
    {bank12: "SBR Bank", wibor6m:"3M", wibor: 7.02, data:"30.12.2022"},
]




 const oprMillennium = OprMillennium();
 const oprMillenniumBezKonta = OprMillenniumBezKonta();
 const oprPKOBP = OprPKOBP();
 const oprPKOBPStandard = OprPKOBPStandard();
 const oprPKOBK2 = OprPKOBPBK2();
 const oprMbankStałeAct = OprMbankStałeAct();
 const oprMbankStałeInt = OprMbankStałeInt();
 const oprMbankStałeStand = OprMbankStałeStand();
 const oprMbankStałePromo = OprMbankStałePromo();
 const oprMbankStałePromoAct = OprMbankStałePromoAct();
 const oprMbankStałePromoInt = OprMbankStałePromoInt();
 const oprMbankZmiennePromo = OprMbankZmiennePromo();
 const oprMbankZmiennePromoAct = OprMbankZmiennePromoAct();
 const oprMbankZmiennePromoInt = OprMbankZmiennePromoInt();
 const oprMbankZmienneStand = OprMbankZmienneStand();
 const oprMbankZmienneStandAct = OprMbankZmienneStandAct();
 const oprMbankZmienneStandInt = OprMbankZmienneStandInt();
 const oprPEKAOSA = OprPEKAOSA(); 
 const oprPEKAOSACPI = OprPEKAOSACPI();
 const oprPEKAOSAZmienne = OprPEKAOSAZmienne();
 const oprPEKAOSAZmienneCPI = OprPEKAOSAZmienneCPI();
 const oprPEKAOSAZmienneCPIProwizja = OprPEKAOSAZmienneCPIProwizja();
 const oprPEKAOSABK2 = OprPEKAOSABK2();
 const oprPEKAOSABK2bezProwizji = OprPEKAOSABK2bezProwizji();
 const oprIngLekkaRata = OprIngLekkaRata();
 const oprIngLekkaRataZmienne = OprIngLekkaRataZmienne();
 const oprIngŁatwyStart = OprIngŁatwyStart();
 const oprIngŁatwyStartZmienne = OprIngŁatwyStartZmienne();
 const oprIngStandard = OprIngStandard();
 const oprBośBank = OprBośBank();
 const oprBośBankZmienne = OprBośBankZmienne();
 const oprSantanderStałe = OprSantanderStałe();
 const oprSantanderStałeSelect = OprSantanderStałeSelect();
 const oprSantanderZmienneWew = OprSantanderZmienneWew();
 const oprSantanderZmienneWewSelect = OprSantanderZmienneWewSelect();
 const oprSantanderZmienneZew = OprSantanderZmienneZew();
 const oprSantanderZmienneZewSelect = OprSantanderZmienneZewSelect();
 const oprAliorMegaHipo = OprAliorMegaHipo();
 const oprAliorMegaHipoBezUb = OprAliorMegaHipoBezUb();
 const oprAliorOfPromo = OprAliorOfPromo();
 const oprAliorOfSpec = OprAliorOfSpec();
 //const oprAliorOfSpecRef = OprAliorOfSpecRef();
 const oprAliorStandard = OprAliorStandard();
 const oprAliorStandardZUb = OprAliorStandardZUb();
 const oprAliorStałe = OprAliorStałe();
 const oprAliorBK2UbŻycie5 = OprAliorBK2UbŻycie5();
 const oprAliorBK2UbŻycie28 = OprAliorBK2UbŻycie28();
 const oprAliorBK2UbŻycieStand = OprAliorBK2Stand();
 const oprBpsStałe = OprBpsStałe(); 
 const oprBpsZmienne = OprBpsZmienne();


//////////////////////////////////////////////////
 const oprPoStałymMillennium = OprPoStałymMillennium();
 const oprPoStałymSantander = OprPoStałymSantander();
 const oprPoStałymPekao = OprPoStałymPekao();
 const oprPoStałymPekaoBK2 = OprPoStałymPekaoBK2();
 const oprPoStałymPekaoBK2bezProwizji = OprPoStałymPekaoBK2bezProwizji();
 const oprPoStałymBnpH1 = OprPoStałymBnpH1();
 const oprPoStałymBnpH2 = OprPoStałymBnpH2();
 const oprPoStałymBnpStandard = OprPoStałymBnpStandard();
 const oprPoStałymIngLekkaRata = OprPoStałymIngLekkaRata();
 const oprPoStałymIngŁatwystart = OprPoStałymIngŁatwyStart();
 const oprPoStałymIngStandard = OprPoStałymIngStandard();
 const oprPoStałymPKOBK2 = OprPoStałymPKOBK2();
 const oprPoStałymAliorBK2Ub5 = OprPoStałymAliorBK2Ub5();
 const oprPoStałymAliorBK2Ub28 = OprPoStałymAliorBK2Ub28();
 const oprPoStałymAliorBK2Stand = OprPoStałymAliorBK2Stand();

   if (LTV > 0.8){
    lowDownInsurance = 1;
    //intrestRate = intrestRate + insuranceNWW; - funkcja zmiany opr do momentu aż LTV <=80;
   }
  
  
   function compareNumbers(a, b) {
    if (sort ==="sortByName"){return a.bank > b.bank ? 1 : -1}
    if (sort ==="sortByCost"){return a.całkowityKoszt < a.całkowityKoszt? 1 : -1}
    if (sort ==="sortByRate"){return b.rataDocelowa - a.rataDocelowa};
    if (sort ==="sortByTotalCost"){return a.totalCost < b.totalCost ? 1 : -1};
    if (sort ==="sortByInterest"){return a.marża - b.marża};
  }

  function Button(){
    return<button style={buttonStyle}>
    Generuj
  </button>

  }

  function FilterZarobki(data){
   if(data.id > 0 && zarobkiNetto ==="zarobki0" ||  data.id > 0 && zarobkiNetto ==="zarobki4"){return data.id} 
   
   if(zarobkiNetto === "zarobki1"){
      if(data.wymaganeZarobkiNetto < 4999) 
      {return data.id}
    }

    if(zarobkiNetto === "zarobki2"){ 
        if(data.wymaganeZarobkiNetto < 6999) 
        {return data.id}
      }
    
     if(zarobkiNetto === "zarobki3"){     
        if(data.wymaganeZarobkiNetto < 9999) 
            {return data.id}   
          }
} 


  function RataMalejaca(data) {

    if(rataStałaCzymalejąca === "equalrate") {return data.id}
    if(data.rataRówna === 0 && rataStałaCzymalejąca === "decreasingrate") {return data.id}
  }
//<SortowanieTablicyPoID/>
//<br></br>
// <GenerowanieRaty/>  

 // <div>
 // <input value="klik" type="button" onClick={()=>{sortByNumberOfOptions()}}/>
 // {listOfOptions.sort(compareNumbers).map((id)=> {
 //   return (
 //   <p key = {id}>
 //      {id.id} - {id.marża} - {id.rataDocelowa}
 //     
  //  </p>)
// })}
//</div>

  return (
    <form className="calculatorInput">



          <div>
            Kwota kredytu hipotecznego
            <input style={inputStyle} type="number" value={creditValue} onChange={handlecreditValueChange}/>
            <br></br>
            Okres kredytowania
            <input style={inputStyle} type="number" value={loanPeriod} onChange={handleloanPeriodChange}/>
            <br></br>
            Wartość nieruchomości
            <input style={inputStyle} type="number" value={flatValue} onChange={handleflatValueChange}/>

            <select style={inputStyle} value={rataStałaCzymalejąca} onChange={e => setRataStałaCzyMalejąca(e.target.value)}>
            <option value="equalrate">Rata równa</option>
            <option value="decreasingrate">Rata malejąca</option>
         </select>
      
          <label> Oprocentowanie stałe
            <input  style={checkboxStyle1}type="checkbox" checked={fixedInterest} onChange={handleChangeFixedInterest} />
          </label>
          <label> Oprocentowanie zmienne
            <input style={checkboxStyle1} type="checkbox" checked={variableInterest} onChange={handleChangeVariableInterest} />
          </label>
        

          <select style={inputStyle} value={sort} onChange={e => setSort(e.target.value)}>
            <option value="sortByName">Sortowanie alfabetyczne</option>

            <option value="sortByInterest">Sortowanie po oprocentowaniu</option>
        </select>
        <label>Zarobki netto
          <select style={inputStyle} value={zarobkiNetto} onChange={e => setZarobkiNetto(e.target.value)}>
            <option value="zarobki0">dowolne</option>
            <option value="zarobki1">0 - 4999zł</option>
            <option value="zarobki2">5000 - 6999</option>
            <option value="zarobki3">7000 - 9999zł</option>
            <option value="zarobki4">100000 i więcej</option>
        </select>
        </label>
          </div>
        
        <div> 
        <label> Konto z wpływem
            <input  style={checkboxStyle1}type="checkbox" checked={kontoCheckbox} onChange={handleChangekontoCheckbox} />
          </label>
          <label> Karta Kredytowa
            <input style={checkboxStyle1} type="checkbox" checked={kartaKredytowaCheckbox} onChange={handleChangeKartaKredytowaCheckbox} />
          </label>
          <label> Ubezpieczenie Nieruchomości
            <input style={checkboxStyle1} type="checkbox" checked={ubNieruchomościCheckbox} onChange={handleChangeUbNieruchomościCheckbox} />
          </label>
          <label> Ubezpieczenie na życie
            <input style={checkboxStyle1} type="checkbox" checked={ubNaŻycieCheckbox} onChange={handleChangeUbNaŻycieCheckbox} />
          </label>
          <label> Ubezpieczenie od utraty pracy
            <input style={checkboxStyle1} type="checkbox" checked={ubOdUtratyPracyCheckbox} onChange={handleChangeUbOdUtratyPracyCheckbox} />
          </label>
         
        
        </div>

        

        <div>
        <label style={checkboxStyle1}> Wszystkie banki
            <input type="checkbox" checked={wszystkieBankiCheckbox} onChange={handleChangeWszystkieBankiChceckbox} />
          </label>
          <label style={checkboxStyle1}> Bezpieczny kredyt 2%
            <input type="checkbox" checked={inneCheckbox} onChange={handleChangeInneChecbox} />
          </label>
          <label style={checkboxStyle1}> Santander
            <input type="checkbox" checked={santanderCheckbox} onChange={handleChangeSantanderChecbox} />
          </label>
          <label style={checkboxStyle1}> BNP Paribas
            <input type="checkbox" checked={bnpParibasCheckbox} onChange={handleChangeBnpparibasChecbox} />
          </label>
          <label style={checkboxStyle1}> Millennium
            <input type="checkbox" checked={millenniumCheckbox} onChange={handleChangeMillenniumCheckbox} />
          </label>
          <label style={checkboxStyle1}> PKOBP
            <input type="checkbox" checked={pkobpCheckbox} onChange={handleChangePkobpCheckbox} />
          </label>
          <label style={checkboxStyle1}> mBank
            <input type="checkbox" checked={mbankCheckbox} onChange={handleChangeMbankCheckbox} />
          </label>
          <label style={checkboxStyle1}> PEKAO SA
            <input type="checkbox" checked={pekaoSACheckbox} onChange={handleChangePekaoSACheckbox} />
          </label>
          <label style={checkboxStyle1}> Citi Handlowy
            <input type="checkbox" checked={citiHandlowyCheckbox} onChange={handleChangeCitiHandlowyCheckbox} />
          </label>
          <label style={checkboxStyle1}> Boś Bank
            <input type="checkbox" checked={bośBankCheckbox} onChange={handleChangeBośBankCheckbox} />
          </label>
          <label style={checkboxStyle1}> ING Bank
            <input type="checkbox" checked={ingBankCheckbox} onChange={handleChangeIngBankCheckbox} />
          </label>
          <label style={checkboxStyle1}> Alior Bank
            <input type="checkbox" checked={aliorCheckbox} onChange={handleChangeAliorChecbox} />
          </label>
          <label style={checkboxStyle1}> BPS
            <input type="checkbox" checked={BpsCheckbox} onChange={handleChangeBpsChecbox} />
          </label>

        </div>
                 
      
        LTV=
        {LTV*100}%
       
        Dostępnych ofert <IleKolumn/> z <IleKolumnWszystkich/>  
        <br></br>   
        <>Autor Marek Kozera - pytania pod 787976915 - zawodowo zajmuj się kredytami więc mogę pomóc.</>

        <table style={tableStyle}>
        
          <tr>
                {columns.map(({label})=>{     
                  const tdata2 = columns[label] ? columns[label] : "---"; 
                  return(
                <tr style={tableStyleHeader} key={label}>{label}</tr>)})
                }      
       
                {tableData.filter(data => data.oprocentowanieStaleCzZmienne ==="Stałe" && fixedInterest || data.oprocentowanieStaleCzZmienne ==="Zmienne" && variableInterest).filter(data => 
                data.bank==="Santander" && santanderCheckbox || data.bank==="BNP Paribas" && bnpParibasCheckbox || data.bank==="Millennium" && millenniumCheckbox || data.bank==="PKOBP" && pkobpCheckbox
                || data.bank === "mbank" && mbankCheckbox || data.bank === "PEKAOSA" && pekaoSACheckbox || data.bank === "CITIHandlowy" && citiHandlowyCheckbox || data.bank === "BOŚ Bank" && bośBankCheckbox || data.bank === "ING" && ingBankCheckbox || data.bank === "Alior" && aliorCheckbox ||data.bank === "BPS" && BpsCheckbox || data.nazwaOferty ==="Bezpieczny Kredyt 2%" && inneCheckbox
                ).filter(data => data.kwotaKredytuOd <= creditValue && data.kwotaKredytuDo >= creditValue).filter(FilterZarobki).filter(RataMalejaca).filter(data => data.maxLTV >= LTV).sort(compareNumbers).map((data)=>{  
                  
                  data.harmonogram = <Button/>
                  
                  
                  if(data.id===1) {
                    data.marża = oprBnpH15
                  };     //BNP
                  if(data.id===2) {
                    data.marża = oprBnpH110;
                  };
                  if(data.id===3) {
                    data.marża = oprBnpH25;
                  };
                  if(data.id===4) {
                    data.marża = oprBnpH210;
                  };
                  if(data.id===5) {
                    data.marża = oprBnpStan5;
                  };
                  if(data.id===6) {
                    data.marża = oprBnpStan10;
                  };

                  if(data.id===10) {
                    data.marża = oprIngLekkaRata;
                  };  //ING
                  if(data.id===11) {
                    data.marża = oprIngŁatwyStart;
                  };
                  if(data.id===46) {
                    data.marża = oprIngStandard;
                  }

                  if(data.id === 51){data.marża = oprIngLekkaRataZmienne + data.wibor}
                  if(data.id === 52){data.marża = oprIngŁatwyStartZmienne + data.wibor}

                  if(data.id===35) {data.marża = oprAliorOfSpec + data.wibor};     //Alior
                 // if(data.id===34) {data.marża = oprAliorOfSpecRef + data.wibor};
                //if(data.id===33) {data.marża = oprAliorOfPromo + data.wibor};
                  if(data.id===36) {data.marża = oprAliorMegaHipo + data.wibor};
                  if(data.id===37) {data.marża = oprAliorMegaHipoBezUb + data.wibor};
                  if(data.id===42) {data.marża = oprAliorStandard + data.wibor};
                  if(data.id===43) {data.marża = oprAliorStandardZUb + data.wibor};

                  if(data.id === 56){data.marża = oprAliorBK2UbŻycie28}
                  if(data.id === 57){data.marża = oprAliorBK2UbŻycie5}
                  if(data.id === 58){data.marża = oprAliorBK2UbŻycieStand}
                  
                 // if(data.id===40) {data.marża = oprAliorStałe };

                  if(data.id === 7) {data.marża = oprMillennium}; //Millennium
                  if(data.id === 8) {data.marża = oprMillenniumBezKonta};

                  if(data.id === 9) {data.marża = oprPKOBP + data.wibor}; // PKOBP
                  if(data.id === 44) {data.marża = oprPKOBPStandard + data.wibor}; // PKOBP
                  if(data.id === 53 || data.id === 59 || data.id === 60) {data.marża = oprPKOBK2}

                  if(data.bank ==="PEKAOSA"){data.marża = oprPEKAOSA}            //PEKAO SA
                  if(data.bank ==="PEKAOSA" && data.id===14){data.marża = oprPEKAOSACPI}
                  if(data.bank ==="PEKAOSA" && data.id===15){data.marża = oprPEKAOSAZmienne + data.wibor }
                  if(data.bank ==="PEKAOSA" && data.id===16){data.marża = oprPEKAOSAZmienneCPI + data.wibor}
                  if(data.bank ==="PEKAOSA" && data.id===17){data.marża = oprPEKAOSAZmienneCPIProwizja + data.wibor}
                  if(data.id === 54){data.marża = oprPEKAOSABK2}
                  if(data.id === 55){data.marża = oprPEKAOSABK2bezProwizji}

                  if(data.bank ==="mbank" && data.id===20){data.marża = oprMbankStałePromo} // mbank
                  if(data.bank ==="mbank" && data.id===22){data.marża = oprMbankStałePromoInt}
                  if(data.bank ==="mbank" && data.id===21){data.marża = oprMbankStałePromoAct}
                  if(data.bank ==="mbank" && data.id===23){data.marża = oprMbankStałeStand}
                  if(data.bank ==="mbank" && data.id===25){data.marża = oprMbankStałeInt}
                  if(data.bank ==="mbank" && data.id===24){data.marża = oprMbankStałeAct }
                  if(data.bank ==="mbank" && data.id===26){data.marża = oprMbankZmiennePromo + data.wibor}
                  if(data.bank ==="mbank" && data.id===28){data.marża = oprMbankZmiennePromoInt + data.wibor}
                  if(data.bank ==="mbank" && data.id===27){data.marża = oprMbankZmiennePromoAct + data.wibor}
                  if(data.bank ==="mbank" && data.id===29){data.marża = oprMbankZmienneStand + data.wibor}
                  if(data.bank ==="mbank" && data.id===31){data.marża = oprMbankZmienneStandInt + data.wibor}
                  if(data.bank ==="mbank" && data.id===30){data.marża = oprMbankZmienneStandAct + data.wibor}

                  if(data.id === 19){data.marża = oprBośBank}  //BOŚ Bank
                  if(data.id === 50){data.marża = oprBośBankZmienne + data.wibor}

                  if(data.id === 12){data.marża = oprSantanderStałe} //Santander
                  if(data.id === 47){data.marża = oprSantanderStałeSelect}
                  if(data.id=== 38){data.marża = oprSantanderZmienneWew + data.wibor}
                  if(data.id=== 40){data.marża = oprSantanderZmienneWewSelect + data.wibor}
                  if(data.id=== 39){data.marża = oprSantanderZmienneZew + data.wibor}
                  if(data.id=== 41){data.marża = oprSantanderZmienneZewSelect + data.wibor}

                  if(data.bank === "Santander" && ubNaŻycieCheckbox){data.prowizja = 0}
                  if(data.bank === "Santander" && !ubNaŻycieCheckbox){
                    data.prowizja = 2;
                    data.ubezpieczenieNaŻycie = 0;
                  }
                  if(data.id === 50 && ubNaŻycieCheckbox){
                    data.prowizja = 0;
                    data.ubezpieczenieNaŻycie = 0.022;
                  }
                  if(data.id === 50 && !ubNaŻycieCheckbox){
                    data.prowizja = 2.2;
                    data.ubezpieczenieNaŻycie = 0;
                  }
                
                 // if(data.id === 53 && ubOdUtratyPracyCheckbox){
                 //   if(data.id === 53 && ubNaŻycieCheckbox){
                 //     data.prowizja = 0;
                 //     data.ubezpieczenieOdUtratyPracy = 3.25;                    
                 //   }       
                //  }

                //  if(data.id === 53 && ubOdUtratyPracyCheckbox){
                //    if(data.id === 53 && !ubNaŻycieCheckbox){
                //      data.prowizja = 0;
                //      data.ubezpieczenieOdUtratyPracy = 3.25;                   
                //   }       
                //  }
                //  if(data.id === 53 && !ubOdUtratyPracyCheckbox){
                //   if(data.id === 53 && ubNaŻycieCheckbox){
                //     data.prowizja = 0.5;
                 //     data.ubezpieczenieOdUtratyPracy = 0; 
                //      data.ubezpieczenieNaŻycie = 0;                    
                //    }       
                //  }
                //  if(data.id === 53 && !ubOdUtratyPracyCheckbox){
                //    if(data.id === 53 && !ubNaŻycieCheckbox){
                //      data.prowizja = 1.7;
                //     data.ubezpieczenieOdUtratyPracy = 0;  
                //      data.ubezpieczenieNaŻycie = 0;                   
                //    }       
                //  }
                  
                  if(data.id === 99){data.marża = 2}

                  if(data.id === 48){data.marża = oprBpsStałe} ///BPS
                  if(data.id === 49){data.marża = oprBpsZmienne + data.wibor}

                  ////////////////////////////////////////////////////
                  if(data.bank === "Millennium"){data.marzaPoOkresieStalego = oprPoStałymMillennium}
                  if(data.id === 13){data.marzaPoOkresieStalego = oprPoStałymPekao}
                  if(data.id === 14){data.marzaPoOkresieStalego = oprPoStałymPekao}
                  if(data.id === 54){data.marzaPoOkresieStalego = oprPoStałymPekaoBK2}
                  if(data.id === 55){data.marzaPoOkresieStalego = oprPoStałymPekaoBK2bezProwizji}
                  if(data.id === 12 ){data.marzaPoOkresieStalego = oprPoStałymSantander} 
                  if(data.id === 47){data.marzaPoOkresieStalego = oprPoStałymSantander}//do poprawy id
                  if(data.id === 1 ){data.marzaPoOkresieStalego = oprPoStałymBnpH1}
                  if(data.id === 3 ){data.marzaPoOkresieStalego = oprPoStałymBnpH1}
                  if(data.id === 2){data.marzaPoOkresieStalego = oprPoStałymBnpH2}
                  if(data.id === 4){data.marzaPoOkresieStalego = oprPoStałymBnpH2}
                  if(data.id === 5 || data.id === 6){data.marzaPoOkresieStalego = oprPoStałymBnpStandard}
                  if(data.id === 10){data.marzaPoOkresieStalego = oprPoStałymIngLekkaRata}
                  if(data.id === 11){data.marzaPoOkresieStalego = oprPoStałymIngŁatwystart}
                  if(data.id === 46){data.marzaPoOkresieStalego = oprPoStałymIngStandard}
                  if(data.id === 53 || data.id === 59 || data.id === 60){data.marzaPoOkresieStalego = oprPoStałymPKOBK2}
                  if(data.id === 56){data.marzaPoOkresieStalego = oprPoStałymAliorBK2Ub28}
                  if(data.id === 57){data.marzaPoOkresieStalego = oprPoStałymAliorBK2Ub5}
                  if(data.id === 58){data.marzaPoOkresieStalego = oprPoStałymAliorBK2Stand}
                  //rata przejściowa nie jest ogarnięta
                  //data.marża2 =<CalculateInterest id={data.id} LTV={LTV}/>;
                  
                  if(data.okresUbZycie === 0){data.okresUbZycie = loanPeriod}

                                    

                  //if(data.marzaPoOkresieStalego === "" && data.oprocentowanieStaleCzZmienne ==="Stałe"){
                    //data.marża2 = <OprPoStałym creditValue={creditValue} flatValue={flatValue} id={data.id}/>
                  //}
                  
                 // if(!ubNieruchomościCheckbox){
                  //  data.kosztZBanku = 0;
                  //}
                
                 
                  data.ubezpieczenieNieruchomosciskładka = <FlatInsurance creditValue={creditValue} flatInsuranceCost={data.kosztZBanku}/>;
                  data.ubNieruchomościpełnykoszt = data.kosztZBanku * loanPeriod * creditValue;
                
                  data.ubezpieczenieNaŻycieSkładka = <LifeInsurance creditValue={creditValue} lifeInsurance={data.ubezpieczenieNaŻycie}/>
                  data.ubezpieczenieNaŻyciePełnyKoszt = <LifeInsuranceTotal id={data.id} jakaSkładka={data.ubezpieczenieNaŻycieJakaSkładka}  creditValue={creditValue} loanPeriod={loanPeriod} lifeInsurance={data.ubezpieczenieNaŻycie} interestRate={data.marża} insurancePeriod={data.okresUbZycie}/>
                  //if(data.id === 53 || data.id === 9 || data.id === 44){data.ubezpieczenieNaŻyciePełnyKoszt = <PkoBPBK2Insurance creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża} insurancePeriod={data.okresUbZycie}/>}
            
                  
                  data.RRSO = <Calculate interestRate={data.marża} installmentNumber={loanPeriod} commision = {data.prowizja} amount={creditValue} additionalCreditCosts={0} LTV={LTV} id={data.id}/>
                                   
                  data.ubezpieczenieOdUtratyPracyKoszt = data.ubezpieczenieOdUtratyPracy * creditValue/100;
                  data.całkowityKosztInne = <TotalCostInne creditValue={creditValue} comission={data.prowizja} ubNieruchomości={data.ubNieruchomościpełnykoszt} jakaSkładka={data.ubezpieczenieNaŻycieJakaSkładka} loanPeriod={loanPeriod} lifeInsurance={data.ubezpieczenieNaŻycie} interestRate={data.marża} insurancePeriod={data.okresUbZycie} ubPraca={data.ubezpieczenieOdUtratyPracy}/>
                  
                  
                  if(data.id === 53){data.sumaDopłat = <BezpiecznyKredytKosztSumaDopłat creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                  if(data.id === 54){data.sumaDopłat = <BezpiecznyKredytKosztSumaDopłat creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                  if(data.id === 55){data.sumaDopłat = <BezpiecznyKredytKosztSumaDopłat creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                  if(data.id === 56){data.sumaDopłat = <BezpiecznyKredytKosztSumaDopłat creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                  if(data.id === 57){data.sumaDopłat = <BezpiecznyKredytKosztSumaDopłat creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                  if(data.id === 58){data.sumaDopłat = <BezpiecznyKredytKosztSumaDopłat creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                  if(data.id === 59){data.sumaDopłat = <BezpiecznyKredytKosztSumaDopłat creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                  if(data.id === 60){data.sumaDopłat = <BezpiecznyKredytKosztSumaDopłat creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}

                  //if (data.id === 33){data.brutto = 
                  data.rata = <PaymentRate2 creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża} id={data.id}/>;
                  

                  if(rataStałaCzymalejąca ==="equalrate"){
                    data.rataDocelowa = <PaymentRate2 creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża}/>;
                    //if(data.id === 99){
                    //  data.rataPrzejsciowa = <BezpiecznyKredytRata creditValue={creditValue} loanPeriod={loanPeriod} />
                    //  data.rataDocelowa = <BezpiecznyKredytRataDocelowa creditValue={creditValue} loanPeriod={loanPeriod} /> 
                    //  }
                    if(data.id === 53 || data.id === 59 || data.id === 60){
                        data.rataPrzejsciowa = <BezpiecznyKredytRata creditValue={creditValue} loanPeriod={loanPeriod} id={data.id} />
                        data.dopłata = <DopłataDoBK2 creditValue = {creditValue}/>
                        data.rataDocelowa = <BezpiecznyKredytRataDocelowa creditValue={creditValue} loanPeriod={loanPeriod} id={data.id} /> 
                      }
                    if(data.id === 54){
                        data.rataPrzejsciowa = <BezpiecznyKredytRata creditValue={creditValue} loanPeriod={loanPeriod} id={data.id} />
                        data.dopłata = <DopłataDoBK2 creditValue = {creditValue}/>
                        data.rataDocelowa = <BezpiecznyKredytRataDocelowa creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/> 
                      }
                    if(data.id === 55){
                        data.rataPrzejsciowa = <BezpiecznyKredytRata creditValue={creditValue} loanPeriod={loanPeriod} id={data.id} />
                        data.dopłata = <DopłataDoBK2 creditValue = {creditValue}/>
                        data.rataDocelowa = <BezpiecznyKredytRataDocelowa creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/> 
                      }
                    if(data.id === 56){
                        data.rataPrzejsciowa = <BezpiecznyKredytRata creditValue={creditValue} loanPeriod={loanPeriod} id={data.id} />
                        data.dopłata = <DopłataDoBK2 creditValue = {creditValue}/>
                        data.rataDocelowa = <BezpiecznyKredytRataDocelowa creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/> 
                      }  
                    if(data.id === 57){
                        data.rataPrzejsciowa = <BezpiecznyKredytRata creditValue={creditValue} loanPeriod={loanPeriod} id={data.id} />
                        data.dopłata = <DopłataDoBK2 creditValue = {creditValue}/>
                        data.rataDocelowa = <BezpiecznyKredytRataDocelowa creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/> 
                      }
                    if(data.id === 58){
                        data.rataPrzejsciowa = <BezpiecznyKredytRata creditValue={creditValue} loanPeriod={loanPeriod} id={data.id} />
                        data.dopłata = <DopłataDoBK2 creditValue = {creditValue}/>
                        data.rataDocelowa = <BezpiecznyKredytRataDocelowa creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/> 
                      }
                    }
                    data.całkowityKoszt = <TotalCost creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża} commission={data.prowizja} firstYearInterest={data.marża1Rok} wibor={data.wibor}/>
                    if(data.id === 9){data.całkowityKoszt = <TotalCostPkobp creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża} commission={data.prowizja} wibor={7} firstYearInterest={data.marża1Rok}/>}
                    
                    if(data.id === 53){data.całkowityKoszt = <BezpiecznyKredytKosztCałkowity creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                    if(data.id === 54){data.całkowityKoszt = <BezpiecznyKredytKosztCałkowity creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                    if(data.id === 55){data.całkowityKoszt = <BezpiecznyKredytKosztCałkowity creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                    if(data.id === 56){data.całkowityKoszt = <BezpiecznyKredytKosztCałkowity creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                    if(data.id === 57){data.całkowityKoszt = <BezpiecznyKredytKosztCałkowity creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                    if(data.id === 58){data.całkowityKoszt = <BezpiecznyKredytKosztCałkowity creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                    if(data.id === 59){data.całkowityKoszt = <BezpiecznyKredytKosztCałkowity creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                    if(data.id === 60){data.całkowityKoszt = <BezpiecznyKredytKosztCałkowity creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/>}
                    data.całkowityKosztWszystkiego = <TotalCost creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża} commission={data.prowizja} lifeInsurance={data.ubezpieczenieNaŻycie} insurancePeriod={data.okresUbZycie} firstYearInterest={data.marża1Rok} wibor={data.wibor}/>
                  


                    if(data.oprocentowanieStaleCzZmienne==="Stałe"){
                      data.całkowityKosztOprStałe = <TotalCostFixed fixedPeriod={data.staleNa5czy10Lat} creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża} commission={data.prowizja} interestRateVaribale={data.marzaPoOkresieStalego + data.wibor} creditValue2={creditValue}/>
                      data.całkowityKosztWszystkiego = <TotalCostFixed fixedPeriod={data.staleNa5czy10Lat} creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża} commission={data.prowizja} interestRateVaribale={data.marzaPoOkresieStalego + data.wibor} creditValue2={creditValue} lifeInsurance={data.ubezpieczenieNaŻycie} insurancePeriod={data.okresUbZycie}/>
                   
                    }
                 
                  if(rataStałaCzymalejąca ==="decreasingrate"){
                    data.rataDocelowa = <PaymentRateDecreasing creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża}/>;
                    data.całkowityKoszt = <TotalCostDecreasing creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża} commission={data.prowizja} />;
                    data.całkowityKosztWszystkiego = <TotalCostDecreasing creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża} commission={data.prowizja} lifeInsurance={data.ubezpieczenieNaŻycie} insurancePeriod={data.okresUbZycie}/>;

                    if(data.id === 53 || data.id === 59 || data.id === 60){
                      data.rataDocelowa = <BezpiecznyKredytRataDocelowaDecreasing creditValue={creditValue} loanPeriod={loanPeriod} id={data.id} /> 
                    }
                  if(data.id === 54){
                      data.rataDocelowa = <BezpiecznyKredytRataDocelowaDecreasing creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/> 
                    }
                  if(data.id === 55){
                      data.rataDocelowa = <BezpiecznyKredytRataDocelowaDecreasing creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/> 
                    }
                  if(data.id === 56){
                      data.rataDocelowa = <BezpiecznyKredytRataDocelowaDecreasing creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/> 
                    }  
                  if(data.id === 57){
                      data.rataDocelowa = <BezpiecznyKredytRataDocelowaDecreasing creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/> 
                    }
                  if(data.id === 58){
                      data.rataDocelowa = <BezpiecznyKredytRataDocelowaDecreasing creditValue={creditValue} loanPeriod={loanPeriod} id={data.id}/> 
                    }

                    
                    if(data.oprocentowanieStaleCzZmienne==="Stałe"){
                      data.całkowityKosztOprStałe = <TotalCostDecreasingFixed fixedPeriod={data.staleNa5czy10Lat} creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża} commission={data.prowizja} interestRateVaribale={data.marzaPoOkresieStalego + data.wibor} creditValue2={creditValue}/>;
                      data.całkowityKosztWszystkiego = <TotalCostDecreasingFixed creditValue={creditValue} loanPeriod={loanPeriod} interestRate={data.marża} commission={data.prowizja} lifeInsurance={data.ubezpieczenieNaŻycie} insurancePeriod={data.okresUbZycie}/>;
                    }
                  }
              
                return(
              
                <td key={data}>
                  
                  
                  {columns.map(({accessor})=>{
                        const tData=data[accessor] ? data[accessor] : "---";              
                        return <tr style={td} key={accessor}>{tData}</tr>
                      
                    })}                               
                </td>
                )
              
              }
              )}

            
              
                
                
        </tr>
       
      </table>


      
      
     Autor Marek Kozera
    </form>
    
    

  );



  function OprIngLekkaRata(){
    let oprIngLekkaRata = 7.84 + 0.8; 
    if(kontoCheckbox){
      oprIngLekkaRata = oprIngLekkaRata - 0.4;
        if(kartaKredytowaCheckbox){
          oprIngLekkaRata = oprIngLekkaRata;
          if(ubNieruchomościCheckbox){
            oprIngLekkaRata = oprIngLekkaRata - 0;
            if(ubNaŻycieCheckbox){
              oprIngLekkaRata = oprIngLekkaRata - 0.4;
            }
          }
        }
    }
      return oprIngLekkaRata.toFixed(2);
  }

  function OprIngLekkaRataZmienne(){
    let oprIngLekkaRataZmienne = 2.34 + 0.8; 
    if(kontoCheckbox){
      oprIngLekkaRataZmienne = oprIngLekkaRataZmienne - 0.4;
        if(kartaKredytowaCheckbox){
          oprIngLekkaRataZmienne = oprIngLekkaRataZmienne;
          if(ubNieruchomościCheckbox){
            oprIngLekkaRataZmienne = oprIngLekkaRataZmienne - 0;
            if(ubNaŻycieCheckbox){
              oprIngLekkaRataZmienne = oprIngLekkaRataZmienne - 0.4;
            }
          }
        }
    }
      return oprIngLekkaRataZmienne;
  }


  function OprIngŁatwyStart(){
    let oprIngŁatwyStart = 7.89 + 0.8;
    if(kontoCheckbox){
      oprIngŁatwyStart = oprIngŁatwyStart - 0.4;
        if(kartaKredytowaCheckbox){
          oprIngŁatwyStart = oprIngŁatwyStart;
          if(ubNieruchomościCheckbox){
            oprIngŁatwyStart = oprIngŁatwyStart - 0;
            if(ubNaŻycieCheckbox){
              oprIngŁatwyStart = oprIngŁatwyStart - 0.4;
            }
          }
        }
    }
      return oprIngŁatwyStart.toFixed(2);
  }

  function OprIngŁatwyStartZmienne(){
    let oprIngŁatwyStartZmienne = 2.39 + 0.8;
    if(kontoCheckbox){
      oprIngŁatwyStartZmienne = oprIngŁatwyStartZmienne - 0.4;
        if(kartaKredytowaCheckbox){
          oprIngŁatwyStartZmienne = oprIngŁatwyStartZmienne;
          if(ubNieruchomościCheckbox){
            oprIngŁatwyStartZmienne = oprIngŁatwyStartZmienne - 0;
            if(ubNaŻycieCheckbox){
              oprIngŁatwyStartZmienne = oprIngŁatwyStartZmienne - 0.4;
            }
          }
        }
    }
      return oprIngŁatwyStartZmienne;
  }

    function OprIngStandard(){
    let oprIngStandard = 8.79;

      return oprIngStandard;
  }


  function OprBnpH15(){
    let oprBnpH15 = 8.6;
  
    if(kontoCheckbox){
      oprBnpH15 = oprBnpH15 - 0.3;
        if(kartaKredytowaCheckbox){
          oprBnpH15 = oprBnpH15;
          if(ubNieruchomościCheckbox){
            oprBnpH15 = oprBnpH15 - 0.1;
            if(ubNaŻycieCheckbox){
              oprBnpH15 = oprBnpH15 - 0.6;
            }
          }
        }
    }
    
      return oprBnpH15.toFixed(2);
  }

  function RataBnpH15(){
    
    let paymentRate2 = 0;
     if(rataStałaCzymalejąca ==="equalrate"){
        paymentRate2 = (creditValue*(oprBnpH15/1200)*Math.pow(1 + (oprBnpH15/1200), loanPeriod)) / (Math.pow(1 + (oprBnpH15/1200), loanPeriod) - 1);
     }  
    
     if(rataStałaCzymalejąca ==="decreasingrate"){
       paymentRate2 = (creditValue/loanPeriod) + ((oprBnpH15/1200)*creditValue);
     }
 
     return paymentRate2
   }

  function OprBnpH25(){
    let oprBnpH25 = 8.6;
    
    if(kontoCheckbox){
      oprBnpH25 = oprBnpH25 - 0.3;
        if(kartaKredytowaCheckbox){
          oprBnpH25 = oprBnpH25;
          if(ubNieruchomościCheckbox){
            oprBnpH25 = oprBnpH25 - 0.1;
            if(ubNaŻycieCheckbox){
              oprBnpH25 = oprBnpH25 - 0.4;
            }
          }
        }
    }

      return oprBnpH25.toFixed(2);
  }

  function RataBnpH25(){
    
    let paymentRate2 = 0;
     if(rataStałaCzymalejąca ==="equalrate"){
        paymentRate2 = (creditValue*(oprBnpH25/1200)*Math.pow(1 + (oprBnpH25/1200), loanPeriod)) / (Math.pow(1 + (oprBnpH25/1200), loanPeriod) - 1);
     }  
    
     if(rataStałaCzymalejąca ==="decreasingrate"){
       paymentRate2 = (creditValue/loanPeriod) + ((oprBnpH25/1200)*creditValue);
     }
 
     return paymentRate2
   }


  function OprBnpH110(){
    let oprBnpH110 = 9.1;
    
    if(kontoCheckbox){
      oprBnpH110 = oprBnpH110 - 0.3;
        if(kartaKredytowaCheckbox){
          oprBnpH110 = oprBnpH110;
          if(ubNieruchomościCheckbox){
            oprBnpH110 = oprBnpH110 - 0.1;
            if(ubNaŻycieCheckbox){
              oprBnpH110 = oprBnpH110 - 0.6;
            }
          }
        }
    }
      return oprBnpH110;
  }
  function RataBnpH110(){
    
    let paymentRate2 = 0;
     if(rataStałaCzymalejąca ==="equalrate"){
        paymentRate2 = (creditValue*(oprBnpH110/1200)*Math.pow(1 + (oprBnpH110/1200), loanPeriod)) / (Math.pow(1 + (oprBnpH110/1200), loanPeriod) - 1);
     }  
    
     if(rataStałaCzymalejąca ==="decreasingrate"){
       paymentRate2 = (creditValue/loanPeriod) + ((oprBnpH110/1200)*creditValue);
     }
 
     return paymentRate2
   }

  function OprBnpH210(){
    let oprBnpH210 = 9.1;
    if(kontoCheckbox){
      oprBnpH210 = oprBnpH210 - 0.3;
        if(kartaKredytowaCheckbox){
          oprBnpH210 = oprBnpH210;
          if(ubNieruchomościCheckbox){
            oprBnpH210 = oprBnpH210 - 0.1;
            if(ubNaŻycieCheckbox){
              oprBnpH210 = oprBnpH210 - 0.4;
            }
          }
        }
    }
      return oprBnpH210;
  }

  function RataBnpH210(){
    
    let paymentRate2 = 0;
     if(rataStałaCzymalejąca ==="equalrate"){
        paymentRate2 = (creditValue*(oprBnpH210/1200)*Math.pow(1 + (oprBnpH210/1200), loanPeriod)) / (Math.pow(1 + (oprBnpH210/1200), loanPeriod) - 1);
     }  
    
     if(rataStałaCzymalejąca ==="decreasingrate"){
       paymentRate2 = (creditValue/loanPeriod) + ((oprBnpH210/1200)*creditValue);
     }
 
     return paymentRate2
   }

  function OprBnpStan5(){
    let oprBnpStan5 = 8.6;
    
      return oprBnpStan5;
  }

  function RataBnpStan5(){
    
    let paymentRate2 = 0;
     if(rataStałaCzymalejąca ==="equalrate"){
        paymentRate2 = (creditValue*(oprBnpStan5/1200)*Math.pow(1 + (oprBnpStan5/1200), loanPeriod)) / (Math.pow(1 + (oprBnpStan5/1200), loanPeriod) - 1);
     }  
    
     if(rataStałaCzymalejąca ==="decreasingrate"){
       paymentRate2 = (creditValue/loanPeriod) + ((oprBnpStan5/1200)*creditValue);
     }
 
     return paymentRate2
   }

  function OprBnpStand10(){
    let oprBnpStan10 = 9.1;
    
      return oprBnpStan10;
  }

  function RataBnpStan10(){
    
    let paymentRate2 = 0;
     if(rataStałaCzymalejąca ==="equalrate"){
        paymentRate2 = (creditValue*(oprBnpStan10/1200)*Math.pow(1 + (oprBnpStan10/1200), loanPeriod)) / (Math.pow(1 + (oprBnpStan10/1200), loanPeriod) - 1);
     }  
    
     if(rataStałaCzymalejąca ==="decreasingrate"){
       paymentRate2 = (creditValue/loanPeriod) + ((oprBnpStan10/1200)*creditValue);
     }
 
     return paymentRate2
   }

  function OprMillennium(){
    let oprMillennium = 8.37;
    
   if (LTV <=0.601){ oprMillennium = 7.47}
    if (LTV <= 0.801) {
      if(LTV > 0.601){oprMillennium = 7.57 }}
    if (LTV > 0.801) {oprMillennium = 8.37 }
    
  
    return oprMillennium;
  }

  function OprMillenniumBezKonta(){
    let oprMillenniumBezKonta = 7.97;
    
   if (LTV <=0.601){ oprMillenniumBezKonta = 7.97}
    if (LTV <= 0.801) {
      if(LTV > 0.601){oprMillenniumBezKonta = 8.07 }}
    if (LTV > 0.801) {oprMillenniumBezKonta = 8.87 }
    
  
    return oprMillenniumBezKonta;
  }

  function OprMbankStałePromo(){
    let oprMbankStałePromo = 9.24;
    
   if (LTV <0.8){ oprMbankStałePromo = 9.24}
    if (LTV > 0.801) { oprMbankStałePromo = 9.74}
      
  return oprMbankStałePromo;
  }

  function OprMbankStałePromoInt(){
    let oprMbankStałePromoInt = 8.94;
    
   if (LTV <0.8){ oprMbankStałePromoInt = 8.94}
    if (LTV > 0.801) { oprMbankStałePromoInt = 9.44}
      
    return oprMbankStałePromoInt;
  }

  function OprMbankStałePromoAct(){
    let oprMbankStałePromoAct = 9.14;
    
   if (LTV <0.8){ oprMbankStałePromoAct = 9.14}
    if (LTV > 0.801) { oprMbankStałePromoAct = 9.64}
      
  
    return oprMbankStałePromoAct;
  }

  function OprMbankStałeStand(){
    let oprMbankStałeStand = 11.24;
    
   if (LTV <0.8){ oprMbankStałeStand = 11.24}
    if (LTV > 0.801) { oprMbankStałeStand = 11.74}
      
  
    return oprMbankStałeStand;
  }

  function OprMbankStałeInt(){
    let oprMbankStałeInt = 10.94;
    
   if (LTV <0.8){ oprMbankStałeInt = 10.94}
    if (LTV > 0.801) { oprMbankStałeInt = 11.44}
      
  
    return oprMbankStałeInt;
  }

  function OprMbankStałeAct(){
    let oprMbankStałeAct = 11.14;
    
   if (LTV <0.8){ oprMbankStałeAct = 11.14}
    if (LTV > 0.801) { oprMbankStałeAct = 11.64}
      
  
    return oprMbankStałeAct;
  }

  function OprMbankZmiennePromo(){
    let oprMbankZmiennePromo = 3.29;
    
   if (LTV <0.8){ oprMbankZmiennePromo = 3.29}
    if (LTV > 0.801) { oprMbankZmiennePromo = 3.79}
      
  
    return oprMbankZmiennePromo;
  }

  function OprMbankZmiennePromoInt(){
    let oprMbankZmiennePromoInt = 2.99;
    
   if (LTV <0.8){ oprMbankZmiennePromoInt = 2.94}
    if (LTV > 0.801) { oprMbankZmiennePromoInt = 3.49}
      
  
    return oprMbankZmiennePromoInt;
  }

  function OprMbankZmiennePromoAct(){
    let oprMbankZmiennePromoAct = 3.19;
    
   if (LTV <0.8){ oprMbankZmiennePromoAct = 3.19}
    if (LTV > 0.801) { oprMbankZmiennePromoAct = 3.69}
      
  
    return oprMbankZmiennePromoAct;
  }

  function OprMbankZmienneStand(){
    let oprMbankZmienneStand = 5.29;
    
   if (LTV <0.8){ oprMbankZmienneStand = 5.29}
    if (LTV > 0.801) { oprMbankZmienneStand = 5.79}
      
  
    return oprMbankZmienneStand;
  }

  function OprMbankZmienneStandInt(){
    let oprMbankZmienneStandInt = 4.99;
    
   if (LTV <0.8){ oprMbankZmienneStandInt = 4.99}
    if (LTV > 0.801) { oprMbankZmienneStandInt = 5.49}
      
  
    return oprMbankZmienneStandInt;
  }

  function OprMbankZmienneStandAct(){
    let oprMbankZmienneStandAct = 5.19;
    
   if (LTV <0.8){ oprMbankZmienneStandAct = 5.19}
    if (LTV > 0.801) { oprMbankZmienneStandAct = 5.69}
      
  
    return oprMbankZmienneStandAct;
  }



  function OprBośBank(){
    let oprBośBank = 8.5;
    
   if (LTV <0.78){ oprBośBank = 9.51}
    if (LTV >= 0.78) { oprBośBank = 9.78}
      
  
    return oprBośBank;
  }

  
  function OprBośBankZmienne(){
    let oprBośBank = 1.79;
    
         
  
    return oprBośBank;
  }

  function OprPEKAOSA(){
    let oprPEKAOSA = 7.54 + 0.2;
    
   if (LTV <0.8){ oprPEKAOSA = 7.34 + 0.2}
    if (LTV > 0.801) { oprPEKAOSA = 7.54 + 0.2}
      
    if(kontoCheckbox){
      oprPEKAOSA = oprPEKAOSA;
        if(kartaKredytowaCheckbox){
          oprPEKAOSA = oprPEKAOSA - 0.1;
          if(ubNieruchomościCheckbox){
            oprPEKAOSA = oprPEKAOSA - 0.1;
            if(ubNaŻycieCheckbox){
              oprPEKAOSA = oprPEKAOSA;
            }
          }
        }
    
    }  
  
    return oprPEKAOSA.toFixed(2);
  }

  function OprPEKAOSACPI(){
    let oprPEKAOSACPI = 7.72 + 0.35;
    
   if (LTV <0.8){oprPEKAOSACPI = 7.72 + 0.35}
    if (LTV > 0.801) { oprPEKAOSACPI = 7.92 +0.35}
      
    if(kontoCheckbox){
      oprPEKAOSACPI = oprPEKAOSACPI;
        if(kartaKredytowaCheckbox){
          oprPEKAOSACPI = oprPEKAOSACPI - 0.1;
          if(ubNieruchomościCheckbox){
            oprPEKAOSACPI = oprPEKAOSACPI - 0.1;
            if(ubNaŻycieCheckbox){
              oprPEKAOSACPI = oprPEKAOSACPI - 0.15;
            }
          }
        }
    
    }  
    return oprPEKAOSACPI.toFixed(2);
  }

  function OprPEKAOSAZmienne(){
    let oprPEKAOSAZmienne = 1.99 + 0.2;
    
   if (LTV <0.8){ oprPEKAOSAZmienne = 1.99 + 0.2}
    if (LTV > 0.801) { oprPEKAOSAZmienne = 2.6 + 0.2}
      
    if(kontoCheckbox){
      oprPEKAOSAZmienne = oprPEKAOSAZmienne;
        if(kartaKredytowaCheckbox){
          oprPEKAOSAZmienne = oprPEKAOSAZmienne - 0.1;
          if(ubNieruchomościCheckbox){
            oprPEKAOSAZmienne = oprPEKAOSAZmienne - 0.1;
            if(ubNaŻycieCheckbox){
              oprPEKAOSAZmienne = oprPEKAOSAZmienne;
            }
          }
        }
    
    } 
  
    return oprPEKAOSAZmienne;
  }

  
  function OprPEKAOSAZmienneCPI(){
    let oprPEKAOSAZmienneCPI = 1.89 + 0.35;
    
   if (LTV <0.8){ oprPEKAOSAZmienneCPI = 1.89 + 0.35}
    if (LTV > 0.801) { oprPEKAOSAZmienneCPI = 2.5 + 0.35}
      
    if(kontoCheckbox){
      oprPEKAOSAZmienneCPI = oprPEKAOSAZmienneCPI;
        if(kartaKredytowaCheckbox){
          oprPEKAOSAZmienneCPI = oprPEKAOSAZmienneCPI - 0.1;
          if(ubNieruchomościCheckbox){
            oprPEKAOSAZmienneCPI = oprPEKAOSAZmienneCPI - 0.1;
            if(ubNaŻycieCheckbox){
              oprPEKAOSAZmienneCPI = oprPEKAOSAZmienneCPI - 0.15;
            }
          }
        }
    
    } 
  
    return oprPEKAOSAZmienneCPI;
  }

  function OprPEKAOSAZmienneCPIProwizja(){
    let oprPEKAOSAZmienneCPIProwizja = 1.84 + 0.35;
    
   if (LTV < 0.8){ oprPEKAOSAZmienneCPIProwizja = 1.84 + 0.35}
    if (LTV > 0.801) { oprPEKAOSAZmienneCPIProwizja = 2.45 + 0.35}

    if(kontoCheckbox){
      oprPEKAOSAZmienneCPIProwizja = oprPEKAOSAZmienneCPIProwizja;
        if(kartaKredytowaCheckbox){
          oprPEKAOSAZmienneCPIProwizja = oprPEKAOSAZmienneCPIProwizja - 0.1;
          if(ubNieruchomościCheckbox){
            oprPEKAOSAZmienneCPIProwizja = oprPEKAOSAZmienneCPIProwizja - 0.1;
            if(ubNaŻycieCheckbox){
              oprPEKAOSAZmienneCPIProwizja = oprPEKAOSAZmienneCPIProwizja - 0.15;
            }
          }
        }
    
    } 
  
    return oprPEKAOSAZmienneCPIProwizja;
  }

  function OprPEKAOSABK2(){
    let oprPEKAOSABK2 = 7.14;
    
    return oprPEKAOSABK2;
  }

  function OprPEKAOSABK2bezProwizji(){
    let oprPEKAOSABK2bezProwizji = 7.14;

    return oprPEKAOSABK2bezProwizji
  }


  function OprSantanderStałe(){                //////////////Santander
    let oprSantanderStałe = 7.99;
    
    if(LTV < 0.8){oprSantanderStałe = 7.99}
    if(LTV > 0.801){ oprSantanderStałe = 8.69}

    if(kontoCheckbox){
      oprSantanderStałe = oprSantanderStałe - 0.1;
        if(kartaKredytowaCheckbox){
          oprSantanderStałe = oprSantanderStałe - 0.1;
          if(ubNieruchomościCheckbox){
            oprSantanderStałe = oprSantanderStałe - 0.1;
            if(ubNaŻycieCheckbox){
              oprSantanderStałe = oprSantanderStałe - 0.2;
            }
          }
        }
    
    }

    return oprSantanderStałe.toFixed(2);
  }

  function OprSantanderStałeSelect(){                //////////////Santander
    let oprSantanderStałeSelect = 7.89;
  
    if(LTV < 0.8){oprSantanderStałeSelect = 7.89}
    if(LTV > 0.801){ oprSantanderStałeSelect = 8.49}

    if(kontoCheckbox){
      oprSantanderStałeSelect = oprSantanderStałeSelect - 0.1;
        if(kartaKredytowaCheckbox){
          oprSantanderStałeSelect = oprSantanderStałeSelect - 0.1;
          if(ubNieruchomościCheckbox){
            oprSantanderStałeSelect = oprSantanderStałeSelect - 0.1;
            if(ubNaŻycieCheckbox){
              oprSantanderStałeSelect = oprSantanderStałeSelect - 0.2;
            }
          }
        }
    
    }
    
    return oprSantanderStałeSelect.toFixed(2);
    
  }


  function OprSantanderZmienneWew(){
    let oprSantanderZmienneWew = 2.45;
    
   
    if (LTV <= 0.501) {
      if(creditValue < 199999){oprSantanderZmienneWew = 2.45}
      if(creditValue > 200000){oprSantanderZmienneWew = 2.45}
    }
    
  if (LTV > 0.501) {
    if (LTV <= 0.801) {
      if(creditValue < 199999){oprSantanderZmienneWew = 2.45}
      if(creditValue > 200000){oprSantanderZmienneWew = 2.45}
      }}
  
  if (LTV > 0.801){
    if (LTV <= 0.85) {
      if(creditValue < 199999){oprSantanderZmienneWew = 3.09}
      if(creditValue > 200000){oprSantanderZmienneWew = 3.09}
      }}
  
 if (LTV > 0.8501){
    if (LTV <= 0.901) {
      if(creditValue < 199999){oprSantanderZmienneWew = 3.09}
      if(creditValue > 200000){oprSantanderZmienneWew = 3.09}
      }}

 if (LTV > 0.901){
    if (LTV < 1) {
     if(creditValue < 199999){oprSantanderZmienneWew = 3.09}
     if(creditValue > 200000){oprSantanderZmienneWew = 3.09}
 }}      

 if(kontoCheckbox){
  oprSantanderZmienneWew = oprSantanderZmienneWew - 0.1;
    if(kartaKredytowaCheckbox){
      oprSantanderZmienneWew = oprSantanderZmienneWew - 0.1;
      if(ubNieruchomościCheckbox){
        oprSantanderZmienneWew = oprSantanderZmienneWew - 0.1;
        if(ubNaŻycieCheckbox){
          oprSantanderZmienneWew = oprSantanderZmienneWew - 0.2;
        }
      }
    }

}
  
    return oprSantanderZmienneWew;
  }

  function OprSantanderZmienneZew(){
    let oprSantanderZmienneZew = 2.45;
    
   
    if (LTV <= 0.501) {
      if(creditValue < 199999){oprSantanderZmienneZew = 2.45}
      if(creditValue > 200000){oprSantanderZmienneZew = 2.45}
    }
    
  if (LTV > 0.501) {
    if (LTV <= 0.801) {
      if(creditValue < 199999){oprSantanderZmienneZew = 2.45}
      if(creditValue > 200000){oprSantanderZmienneZew = 2.45}
      }}
  
  if (LTV > 0.801){
    if (LTV <= 0.85) {
      if(creditValue < 199999){oprSantanderZmienneZew = 3.19}
      if(creditValue > 200000){oprSantanderZmienneZew = 3.19}
      }}
  
 if (LTV > 0.8501){
    if (LTV <= 0.901) {
      if(creditValue < 199999){oprSantanderZmienneZew = 3.19}
      if(creditValue > 200000){oprSantanderZmienneZew = 3.19}
      }}

 if (LTV > 0.901){
    if (LTV < 1) {
     if(creditValue < 199999){oprSantanderZmienneZew = 3.19}
     if(creditValue > 200000){oprSantanderZmienneZew = 3.19}
 }}      

 if(kontoCheckbox){
  oprSantanderZmienneZew = oprSantanderZmienneZew - 0.1;
    if(kartaKredytowaCheckbox){
      oprSantanderZmienneZew = oprSantanderZmienneZew - 0.1;
      if(ubNieruchomościCheckbox){
        oprSantanderZmienneZew = oprSantanderZmienneZew - 0.1;
        if(ubNaŻycieCheckbox){
          oprSantanderZmienneZew = oprSantanderZmienneZew - 0.2;
        }
      }
    }

}
  
    return oprSantanderZmienneZew;
  }


  function OprSantanderZmienneWewSelect(){
    let oprSantanderZmienneWewSelect = 2.45;
    
   
    if (LTV <= 0.501) {oprSantanderZmienneWewSelect = 2.40}
     
  if (LTV > 0.501) {
    if (LTV <= 0.801) {oprSantanderZmienneWewSelect = 2.40}}
      
  
  if (LTV > 0.801){
    if (LTV <= 0.85) {oprSantanderZmienneWewSelect = 2.99}}
  
 if (LTV > 0.8501){
    if (LTV <= 0.901) {oprSantanderZmienneWewSelect = 2.99}}
     

 if (LTV > 0.901){
    if (LTV < 1) {oprSantanderZmienneWewSelect = 2.99}}
     
    if(kontoCheckbox){
      oprSantanderZmienneWewSelect = oprSantanderZmienneWewSelect - 0.1;
        if(kartaKredytowaCheckbox){
          oprSantanderZmienneWewSelect = oprSantanderZmienneWewSelect - 0.1;
          if(ubNieruchomościCheckbox){
            oprSantanderZmienneWewSelect = oprSantanderZmienneWewSelect - 0.1;
            if(ubNaŻycieCheckbox){
              oprSantanderZmienneWewSelect = oprSantanderZmienneWewSelect - 0.2;
            }
          }
        }
    
    }
  
    return oprSantanderZmienneWewSelect;
  }

  function OprSantanderZmienneZewSelect(){
    let oprSantanderZmienneZewSelect = 2.45;
    
   
  if (LTV <= 0.501) {oprSantanderZmienneZewSelect = 2.40}
     
  if (LTV > 0.501) {
    if (LTV <= 0.801) {oprSantanderZmienneZewSelect = 2.40}}
      
  
  if (LTV > 0.801){
    if (LTV <= 0.85) {oprSantanderZmienneZewSelect = 3.09}}
  
 if (LTV > 0.8501){
    if (LTV <= 0.901) {oprSantanderZmienneZewSelect = 3.09}}
     

 if (LTV > 0.901){
    if (LTV < 1) {oprSantanderZmienneZewSelect = 3.09}}
     
    if(kontoCheckbox){
      oprSantanderZmienneZewSelect = oprSantanderZmienneZewSelect - 0.1;
        if(kartaKredytowaCheckbox){
          oprSantanderZmienneZewSelect = oprSantanderZmienneZewSelect - 0.1;
          if(ubNieruchomościCheckbox){
            oprSantanderZmienneZewSelect = oprSantanderZmienneZewSelect - 0.1;
            if(ubNaŻycieCheckbox){
              oprSantanderZmienneZewSelect = oprSantanderZmienneZewSelect - 0.2;
            }
          }
        }
    
    }


    return oprSantanderZmienneZewSelect;
  }


    function OprPKOBP(){
    
      let oprPKOBP =  3.9;
      
    
     
      if (LTV <= 0.5) {
          if(creditValue < 40000){oprPKOBP = 5.41;}
          if(creditValue > 40001){
          if(creditValue < 79999){oprPKOBP = 3.87}}
          if(creditValue > 80000){
          if(creditValue < 119999){oprPKOBP = 3.36}}
          if(creditValue > 120000){
          if(creditValue < 199999){oprPKOBP = 3.17}}
          if(creditValue > 200000){
          if(creditValue < 399999){oprPKOBP = 2.67}}
          if(creditValue > 400000){
          if(creditValue < 699999){oprPKOBP = 2.63}}
          if(creditValue > 700000){oprPKOBP = 2.59}
        
          }

        
      if (LTV > 0.501) {
        if (LTV <= 0.7) {
          if(creditValue < 40000){oprPKOBP = 4.71;}
          if(creditValue > 40001){
          if(creditValue < 79999){oprPKOBP = 3.25}}
          if(creditValue > 80000){
          if(creditValue < 119999){oprPKOBP = 2.76}}
          if(creditValue > 120000){
          if(creditValue < 199999){oprPKOBP = 2.55}}
          if(creditValue > 200000){
          if(creditValue < 399999){oprPKOBP = 2.04}}
          if(creditValue > 400000){
          if(creditValue < 699999){oprPKOBP = 2.02}}
          if(creditValue > 700000){oprPKOBP = 1.98}
        
          }}
      
      if (LTV > 0.701){
        if (LTV < 0.8) {
          if(creditValue < 40000){oprPKOBP = 4.54;}
          if(creditValue > 40001){
          if(creditValue < 79999){oprPKOBP = 3.24}}
          if(creditValue > 80000){
          if(creditValue < 119999){oprPKOBP = 2.74}}
          if(creditValue > 120000){
          if(creditValue < 199999){oprPKOBP = 2.54}}
          if(creditValue > 200000){
          if(creditValue < 399999){oprPKOBP = 2.03}}
          if(creditValue > 400000){
          if(creditValue < 699999){oprPKOBP = 2.01}}
          if(creditValue > 700000){oprPKOBP = 1.95}
        
          }}
      
      if (LTV > 0.801){
        if(creditValue < 40000){oprPKOBP = 4.05;}
        if(creditValue > 40001){
        if(creditValue < 79999){oprPKOBP = 3.14}}
        if(creditValue > 80000){
        if(creditValue < 119999){oprPKOBP = 2.69}}
        if(creditValue > 120000){
        if(creditValue < 199999){oprPKOBP = 2.44}}
        if(creditValue > 200000){
        if(creditValue < 399999){oprPKOBP = 1.95}}
        if(creditValue > 400000){
        if(creditValue < 699999){oprPKOBP = 1.92}}
        if(creditValue > 700000){oprPKOBP = 1.84}
      
        }
    
      return oprPKOBP;
    }


  function OprPKOBPStandard(){
    
      let oprPKOBPStandard =  2.07;
      
    
     
      if (LTV <= 0.1) {
          if(creditValue < 40000){oprPKOBPStandard = 5.7}
          if(creditValue > 40001){
          if(creditValue < 79999){oprPKOBPStandard = 4.16}}
          if(creditValue > 80000){
          if(creditValue < 119999){oprPKOBPStandard = 3.65}}
          if(creditValue > 120000){
          if(creditValue < 199999){oprPKOBPStandard = 3.45}}
          if(creditValue > 200000){
          if(creditValue < 399999){oprPKOBPStandard = 2.96}}
          if(creditValue > 400000){
          if(creditValue < 699999){oprPKOBPStandard = 2.92}}
          if(creditValue > 700000){oprPKOBPStandard = 2.88}
        
          }

        
      if (LTV > 0.101) {
        if (LTV <= 0.2) {
          if(creditValue < 40000){oprPKOBPStandard = 5.65}
          if(creditValue > 40001){
          if(creditValue < 79999){oprPKOBPStandard = 4.11}}
          if(creditValue > 80000){
          if(creditValue < 119999){oprPKOBPStandard = 3.59}}
          if(creditValue > 120000){
          if(creditValue < 199999){oprPKOBPStandard = 3.4}}
          if(creditValue > 200000){
          if(creditValue < 399999){oprPKOBPStandard = 2.9}}
          if(creditValue > 400000){
          if(creditValue < 699999){oprPKOBPStandard = 2.86}}
          if(creditValue > 700000){oprPKOBPStandard = 2.82}
        
          }}
      
      if (LTV > 0.201){
        if (LTV < 0.3) {
          if(creditValue < 40000){oprPKOBPStandard = 4.95}
          if(creditValue > 40001){
          if(creditValue < 79999){oprPKOBPStandard = 3.49}}
          if(creditValue > 80000){
          if(creditValue < 119999){oprPKOBPStandard = 2.99}}
          if(creditValue > 120000){
          if(creditValue < 199999){oprPKOBPStandard = 2.78}}
          if(creditValue > 200000){
          if(creditValue < 399999){oprPKOBPStandard = 2.27}}
          if(creditValue > 400000){
          if(creditValue < 699999){oprPKOBPStandard = 2.25}}
          if(creditValue > 700000){oprPKOBPStandard = 2.21}
        
          }}
      
        if (LTV > 0.301){
            if (LTV < 0.5) {
              if(creditValue < 40000){oprPKOBPStandard = 4.83}
              if(creditValue > 40001){
              if(creditValue < 79999){oprPKOBPStandard = 3.48}}
              if(creditValue > 80000){
              if(creditValue < 119999){oprPKOBPStandard = 2.97}}
              if(creditValue > 120000){
              if(creditValue < 199999){oprPKOBPStandard = 2.77}}
              if(creditValue > 200000){
              if(creditValue < 399999){oprPKOBPStandard = 2.26}}
              if(creditValue > 400000){
              if(creditValue < 699999){oprPKOBPStandard = 2.24}}
              if(creditValue > 700000){oprPKOBPStandard = 2.18}
            
              }}

      if (LTV > 0.501){
        if(creditValue < 40000){oprPKOBPStandard = 4.28}
        if(creditValue > 40001){
        if(creditValue < 79999){oprPKOBPStandard = 3.37}}
        if(creditValue > 80000){
        if(creditValue < 119999){oprPKOBPStandard = 2.92}}
        if(creditValue > 120000){
        if(creditValue < 199999){oprPKOBPStandard = 2.67}}
        if(creditValue > 200000){
        if(creditValue < 399999){oprPKOBPStandard = 2.18}}
        if(creditValue > 400000){
        if(creditValue < 699999){oprPKOBPStandard = 2.15}}
        if(creditValue > 700000){oprPKOBPStandard = 2.07}
      
        }
    
      return oprPKOBPStandard;
    };

  function OprPKOBPBK2() {
    let oprPKOBK2 = 7.97

    return oprPKOBK2;
  }  

function OprAliorOfSpec(){   ///alior oferta specjalna
  let oprAliorOfSpec = 2.19;

  if(LTV <= 0.8){oprAliorOfSpec = 2.19}
  if(LTV > 0.8){oprAliorOfSpec = 2.39}
  return oprAliorOfSpec
}

//function OprAliorOfSpecRef(){   ///alior oferta specjalna refinansowanie
  //let oprAliorOfSpecRef = 1.69;

// if(LTV <= 0.8){oprAliorOfSpecRef = 1.69}
//  if(LTV > 0.8){oprAliorOfSpecRef = 1.89}
// return oprAliorOfSpecRef
//}

function OprAliorOfPromo(){   ///alior oferta promocyjna
  let oprAliorOfPromo = 1.69;

  if(LTV <= 0.8){oprAliorOfPromo = 1.69}
  if(LTV > 0.8){oprAliorOfPromo = 1.89}
  return oprAliorOfPromo
}

function OprAliorMegaHipo(){   ///alior oferta megahipoteka
  let oprAliorMegaHipo = 2;

  if(LTV <= 0.8){oprAliorMegaHipo = 2} //do 3.59
  if(LTV > 0.8){oprAliorMegaHipo = 22} // do 3.79
  return oprAliorMegaHipo
}

function OprAliorMegaHipoBezUb(){   ///alior oferta megahipoteka bez ubezpieczenia
  let oprAliorMegaHipoBezUb = 2.6;

  if(LTV <= 0.8){oprAliorMegaHipoBezUb = 2.6} //do 4.3
  if(LTV > 0.8){oprAliorMegaHipoBezUb = 2.8} // do 4.5
  return oprAliorMegaHipoBezUb
}

function OprAliorStandard(){   ///alior standard
  let oprAliorStandard = 4.9; // do 6

  return oprAliorStandard
}

function OprAliorStandardZUb(){   ///alior standard
  let oprAliorStandardZUb = 4.70; // do 5.5

  return oprAliorStandardZUb;
}
function OprAliorStałe(){   ///alior stałe
  let oprAliorStałe = 8.054; // 

  return oprAliorStałe
}

function OprAliorBK2UbŻycie5(){
  let oprAliorBK2UbŻycie5 = 6.899;

  return oprAliorBK2UbŻycie5;
}

function OprAliorBK2UbŻycie28(){
  let oprAliorBK2UbŻycie28 = 7.089;

  return oprAliorBK2UbŻycie28;
}

function OprAliorBK2Stand(){
  let oprAliorBK2UbŻycieStand = 7.499;

  return oprAliorBK2UbŻycieStand;
}

function OprBpsStałe(){
  let oprBpsStałe = 8.21;

  if (LTV <0.3) {
    if(creditValue < 100000){oprBpsStałe = 8.51}
    if(creditValue >= 100000){oprBpsStałe = 8.21}
}
if (LTV < 0.301 && LTV > 0.5 ) {
  if(creditValue < 100000){oprBpsStałe = 8.61}
  if(creditValue >= 100000){oprBpsStałe = 8.31}
}
if (LTV < 0.501 && LTV > 0.8 ) {
  if(creditValue < 100000){oprBpsStałe = 8.71}
  if(creditValue >= 100000){oprBpsStałe = 8.51}
}
if (LTV < 0.8501 && LTV > 0.9 ) {
  if(creditValue < 100000){oprBpsStałe = 9.01}
  if(creditValue >= 100000){oprBpsStałe = 8.91}
}

return oprBpsStałe;
}

function OprBpsZmienne(){
  let oprBpsZmienne = 1.89;

  if (LTV <0.3) {
    if(creditValue < 100000){oprBpsZmienne = 2.19}
    if(creditValue >= 100000){oprBpsZmienne = 1.89}
}
if (LTV < 0.301 && LTV > 0.5 ) {
  if(creditValue < 100000){oprBpsZmienne = 2.29}
  if(creditValue >= 100000){oprBpsZmienne = 1.99}
}
if (LTV < 0.501 && LTV > 0.8 ) {
  if(creditValue < 100000){oprBpsZmienne = 2.39}
  if(creditValue >= 100000){oprBpsZmienne = 2.19}
}
if (LTV < 0.8501 && LTV > 0.9 ) {
  if(creditValue < 100000){oprBpsZmienne = 2.69}
  if(creditValue >= 100000){oprBpsZmienne = 2.59}
}

return oprBpsZmienne;
}
  
///////////////////////////////////////////////////////////////

function OprPoStałymMillennium(){

  let oprPoStałymMillennium = 2.9;
    if (LTV <=0.601){ oprPoStałymMillennium = 2.9};
    if (LTV <= 0.801) {
      if(LTV > 0.601){oprPoStałymMillennium = 3 }}
    if (LTV > 0.801) {oprPoStałymMillennium = 3.8};
    return oprPoStałymMillennium;
  };
   
function OprPoStałymSantander(){
  
  let  oprPoStałymSantander = 2.45;
    if (LTV <= 0.501) {oprPoStałymSantander = 2.45};
    
    if (LTV > 0.501 && LTV <= 0.801) {oprPoStałymSantander = 2.45};
   
    if (LTV > 0.801 && LTV <= 0.85){oprPoStałymSantander = 3.09};
    
    if (LTV > 0.8501 && LTV <= 0.901){oprPoStałymSantander = 3.09};
  
    if (LTV > 0.901){oprPoStałymSantander = 3.09};
    
    return oprPoStałymSantander;
  }
  
  
  
  function OprPoStałymPekao(){ 
     let oprPoStałymPekao = 2.84;
          if(creditValue <= 400000){
             if(LTV < 0.801) {oprPoStałymPekao = 2.84}; 
             if(LTV >= 0.8){oprPoStałymPekao = 3.54};
          }
          if(creditValue > 400000){
              if(LTV < 0.801) {oprPoStałymPekao = 2.74};
              if(LTV >= 0.8){oprPoStałymPekao = 3.44};
          }

          return oprPoStałymPekao;
      }

      function OprPoStałymPekaoBK2(){ 
        let oprPoStałymPekaoBK2 = 1.99;
           
           return oprPoStałymPekaoBK2;
         }

         function OprPoStałymPekaoBK2bezProwizji(){ 
          let oprPoStałymPekaoBK2bezProwizji = 2.5;
             
             return oprPoStałymPekaoBK2bezProwizji;
           }   
  
      function OprPoStałymBnpH1(){

        let oprPoStałymBnpH1 = 1.5;
         
          return oprPoStałymBnpH1;
        };

      function OprPoStałymBnpH2(){

          let oprPoStałymBnpH2 = 1.7;
           
            return oprPoStałymBnpH2;
          };

      function OprPoStałymBnpStandard(){

            let oprPoStałymBnpStandard = 2.5;
             
              return oprPoStałymBnpStandard;
            };


      function OprPoStałymIngLekkaRata(){

            let oprPoStałymIngLekkaRata = 2.34;
               
             return oprPoStałymIngLekkaRata;
            };

      function OprPoStałymIngŁatwyStart(){

          let oprPoStałymIngŁatwystart = 2.39;
                 
            return oprPoStałymIngŁatwystart;
           };


      function OprPoStałymIngStandard(){

          let oprPoStałymIngStandard = 2.5;
                 
            return oprPoStałymIngStandard;
           };


        function OprPoStałymPKOBK2(){
          let oprPoStałymPKOBK2 = 2;

          return oprPoStałymPKOBK2;
        }   

        function OprPoStałymAliorBK2Ub5(){
          let oprPoStałymAliorBK2Ub5 = 2;
          return oprPoStałymAliorBK2Ub5
        }

        function OprPoStałymAliorBK2Ub28(){
          let oprPoStałymAliorBK2Ub28 = 2.19;
          return oprPoStałymAliorBK2Ub28
        }

        function OprPoStałymAliorBK2Stand(){
          let oprPoStałymAliorBK2Stand = 2.6;
          return oprPoStałymAliorBK2Stand
        }



      function Harm(){
        let arr = [];
        let id =0;
        let principal = 1000;
        let interest = 8.4;
        tableData.map((i)=>{ 
            {id = id + 1}
                     
           return arr.push(i.id)
         }).sort(); 
      
      arr.map((i) => {
        return (
          <table>
          <tr key={i}>
                <td style={td}>{i + 1}</td>
               
              </tr>
         </table>
        )
      
      }
      
      ) 
      return arr
      }



  }





export default  LoanCalculator;



//export default TaxForm;
